import dhamaValidMoves from "./checkDiagonalEat/dhamaValidMoves";
let boundaries = [
  1, 3, 5, 7, 9, 10, 30, 50, 70, 90, 29, 49, 69, 89, 90, 92, 94, 96, 98,
];
function validMoves(
  playerTurn,
  diagonal,
  matrixOfPawns,
  childNode,
  diagonalRow,
  diagonalCol,
  boardData,
  ifObj,
  node,
  emptyNode,
  row,
  col
) {
  let indexPawn = matrixOfPawns[diagonalRow][diagonalCol];
  let nextPawn = boardData[matrixOfPawns[diagonalRow][diagonalCol]][0];
  if (boundaries.includes(indexPawn) && nextPawn !== 0) {
    ifObj.value = false;
  }
  if (!boundaries.includes(indexPawn)) {
    var nextNextPawn =
      boardData[matrixOfPawns[diagonalRow + row][diagonalCol + col]][0];
    if (playerTurn === 2) {
      if (
        (nextPawn === 1 && nextNextPawn === 1) ||
        (nextPawn === 1 && nextNextPawn === 31) ||
        (nextPawn === 31 && nextNextPawn === 1) ||
        (nextPawn === 31 && nextNextPawn === 31) ||
        (nextPawn === 1 && nextNextPawn === 2) ||
        nextPawn === 2 ||
        nextPawn === 32
      ) {
        ifObj.value = false;
      }
    } else if (playerTurn === 1) {
      if (
        (nextPawn === 2 && nextNextPawn === 2) ||
        (nextPawn === 2 && nextNextPawn === 32) ||
        (nextPawn === 32 && nextNextPawn === 2) ||
        (nextPawn === 32 && nextNextPawn === 32) ||
        (nextPawn === 2 && nextNextPawn === 1) ||
        nextPawn === 1 ||
        nextPawn === 31
      ) {
        ifObj.value = false;
      }
    }
  }

  if (ifObj.value) {
    if (
      ((nextPawn === 1 || nextPawn === 31) &&
        nextNextPawn === 0 &&
        playerTurn === 2) ||
      ((nextPawn === 2 || nextPawn === 32) &&
        nextNextPawn === 0 &&
        playerTurn === 1)
    ) {
      node[diagonal].push(childNode);
    } else if (nextPawn === 0) {
      emptyNode[diagonal].push(childNode);
    }
  }
  return { emptyNode, node };
}

function dhamaMovesInit(
  clickedRow,
  clickedCol,
  matrixOfPawns,
  boardData,
  prevSquareIndex,
  playerTurn
) {
  class Node {
    constructor() {
      this.childrenTopLeft = [];
      this.childrenTopRight = [];
      this.childrenBottomLeft = [];
      this.childrenBottomRight = [];
    }
  }

  const node = new Node(matrixOfPawns[clickedRow][clickedCol]);
  const emptyNode = new Node(matrixOfPawns[clickedRow][clickedCol]);

  const directions = [
    { row: -1, col: -1 }, // Top-left
    { row: -1, col: 1 }, // Top-right
    { row: 1, col: -1 }, // Bottom-left
    { row: 1, col: 1 }, // Bottom-right
  ];

  for (const direction of directions) {
    let diagonalRow = clickedRow + direction.row;
    let diagonalCol = clickedCol + direction.col;
    let ifObj = { value: true };
    while (
      diagonalRow >= 0 &&
      diagonalRow < matrixOfPawns.length &&
      diagonalCol >= 0 &&
      diagonalCol < matrixOfPawns[0].length
    ) {
      const childNode = matrixOfPawns[diagonalRow][diagonalCol];
      switch (`${direction.row}_${direction.col}`) {
        case "-1_-1":
          {
            let diagonal = "childrenTopLeft";
            validMoves(
              playerTurn,
              diagonal,
              matrixOfPawns,
              childNode,
              diagonalRow,
              diagonalCol,
              boardData,
              ifObj,
              node,
              emptyNode,
              direction.row,
              direction.col
            );
          }
          break;
        case "-1_1":
          {
            let diagonal = "childrenTopRight";
            if (ifObj.value) {
              const result = validMoves(
                playerTurn,
                diagonal,
                matrixOfPawns,
                childNode,
                diagonalRow,
                diagonalCol,
                boardData,
                ifObj,
                node,
                emptyNode,
                direction.row,
                direction.col
              );
            }
          }
          break;
        case "1_-1":
          {
            let diagonal = "childrenBottomLeft";
            if (ifObj.value) {
               validMoves(
                playerTurn,
                diagonal,
                matrixOfPawns,
                childNode,
                diagonalRow,
                diagonalCol,
                boardData,
                ifObj,
                node,
                emptyNode,
                direction.row,
                direction.col
              );
            }
          }
          break;
        case "1_1":
          {
            let diagonal = "childrenBottomRight";
            if (ifObj.value) {
              validMoves(
                playerTurn,
                diagonal,
                matrixOfPawns,
                childNode,
                diagonalRow,
                diagonalCol,
                boardData,
                ifObj,
                node,
                emptyNode,
                direction.row,
                direction.col
              );
            }
          }
          break;
        default:
          break;
      }
      // const diagonalNumber = matrixOfPawns[diagonalRow][diagonalCol];
      // diagonalNumbers.push(diagonalNumber);
      if (!ifObj.value) {
        break;
      } else {
        diagonalRow += direction.row;
        diagonalCol += direction.col;
      }
    }
  }

  const { finalAllWays, pawnsToEat } = dhamaValidMoves(
    node,
    emptyNode,
    matrixOfPawns,
    boardData,
    prevSquareIndex,
    playerTurn
  );

  return { finalAllWays: finalAllWays, pawnsToEat: pawnsToEat };
}

export default dhamaMovesInit;
